import React from 'react';

export default () => (
    <svg fill='#1a1a1a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='32px' height='32px'>
        <path d='M 9 5 L 9 8.5488281 L 4.0078125 11.802734 L 4.0078125 28 L 27.992188 28 L 27.992188 11.802734 L 23 8.5507812 L 23 5 L 9 5 z M 11 7 L 21 7 L 21 15.035156 L 16 18.273438 L 11 15.035156 L 11 7 z M 9 10.9375 L 9 13.738281 L 6.84375 12.341797 L 9 10.9375 z M 23 10.9375 L 25.15625 12.341797 L 23 13.738281 L 23 10.9375 z M 6.0078125 14.183594 L 16 20.65625 L 25.992188 14.183594 L 25.992188 26 L 6.0078125 26 L 6.0078125 14.183594 z'/>
    </svg>
);


